import { Box, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import { BaseChip } from "components/BaseChip";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { PartyInvolvedDocuments } from "v2-types/order";
import { getChipStyleByKind } from "../utils";

type Props = {
  data: PartyInvolvedDocuments[]
}

export const PartiesData: FC<Props> = ({ data }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useTranslation('common');

  const parties = data.filter(({ kind }) => kind === "party");
  const signers = data.filter(({ kind }) => kind === "signer");
  const properties = data.filter(({ kind }) => kind === "property");

  const partyStyles = getChipStyleByKind("party");
  const signerStyles = getChipStyleByKind("signer");
  const propertyStyles = getChipStyleByKind("property");

  const gap = isMobile ? "6px" : "10px";

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      gap={gap}
      flexWrap="wrap"
      columnGap={gap}
      width="100%"
    >
      {parties.length > 0 && parties.map(({ kinds, name }) => (
        <div key={`party-${name}`} style={{ minWidth: 0, width: isMobile ? '100%' : 'auto' }}>
          <BaseChip
            label={t('party')}
            text={`${name} (${kinds?.join(", ")})`}
            backgroundColor={partyStyles.backgroundColor}
            color={partyStyles.color}
          />
        </div>
      ))}

      {signers.length > 0 && signers.map(({ kinds, name }) => (
        <div key={`signer-${name}`} style={{ minWidth: 0, width: isMobile ? '100%' : 'auto' }}>
          <BaseChip
            label={t('signer')}
            text={`${name} (${kinds?.join(", ")})`}
            backgroundColor={signerStyles.backgroundColor}
            color={signerStyles.color}
          />
        </div>
      ))}

      {properties.length > 0 && properties.map(({ address }) => (
        <Tooltip key={`property-${address}`} title={address!} placement="left">
          <div style={{ minWidth: 0, width: isMobile ? '100%' : 'auto' }}>
            <BaseChip
              label={t('property')}
              text={address!.length > 53 ? address!.slice(0, 50).concat("...") : address!}
              backgroundColor={propertyStyles.backgroundColor}
              color={propertyStyles.color}
            />
          </div>
        </Tooltip>
      ))}
    </Box>
  );
};
